import React, { forwardRef, memo, useState } from 'react';
import { withBillingWriteAccess } from 'contexts/adminAccess';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import { useParams } from 'react-router-dom';

import ReleaseAchFundsDialog from './ReleaseAchFundsDialog';

import { AchActionProps } from './achVerificationTypes';

// RLPR-20420 transaction action: credit the pending part of an ACH deposit before Stripe settles it
const ReleaseAchFundsField = forwardRef<HTMLLIElement, AchActionProps>((props, ref) => {
  const { record, hideAction } = props;

  const { id } = useParams<{ id: string }>();

  const [openDialog, setOpenDialog] = useState<boolean>(false);

  if (hideAction) {
    return null;
  }

  return (
    <>
      <Tooltip title="Makes part or all of the pending amount available to the user now; Stripe still settles the debit">
        <MenuItem ref={ref} onClick={() => setOpenDialog(true)}>
          Release pending funds
        </MenuItem>
      </Tooltip>

      {openDialog && (
        <ReleaseAchFundsDialog
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          userId={id}
          record={record}
        />
      )}
    </>
  );
});

export default withBillingWriteAccess(memo(ReleaseAchFundsField));
